import { useDroppable } from "@dnd-kit/core";
import KanbanCardComponent from "./KanbanCard";
import type { KanbanCard } from "../../../services/whatsapp/whatsappService";

interface KanbanColumnProps {
  id: string;
  title: string;
  cards: KanbanCard[];
  color: string;
}

const KanbanColumn = ({ id, title, cards, color }: KanbanColumnProps) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div className="flex-1 min-w-[250px] max-w-[350px] border-r border-gray-200 last:border-r-0 pr-4">
      <div className="flex items-center gap-2 mb-3 px-1">
        <div className={`w-2 h-2 rounded-full ${color}`} />
        <h3 className="text-sm font-semibold text-gray-700">{title}</h3>
        <span className="text-xs text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded-full">
          {cards.length}
        </span>
      </div>
      <div
        ref={setNodeRef}
        className={`min-h-[200px] p-2 rounded-lg transition-colors ${
          isOver ? "bg-blue-50 ring-2 ring-blue-200" : "bg-gray-50"
        }`}
      >
        {cards.map((card) => (
          <KanbanCardComponent key={card.id} card={card} />
        ))}
        {cards.length === 0 && (
          <div className="text-center text-xs text-gray-400 py-8">
            Sin pedidos
          </div>
        )}
      </div>
    </div>
  );
};

export default KanbanColumn;
